export default __webpack_public_path__ + "static/media/ashley.88f42f2d.jpg";